/* ============================================================
   NH Hostas — Fall demo shared scaffold
   Loaded once per page (script tag repeated per section, browser
   dedupes the request; this guard makes re-execution harmless).
   - scroll reveal: fade + rise 16px via IntersectionObserver
   - count-up: numbers inside a revealed card count up from 0
   Respects prefers-reduced-motion — skips both effects entirely,
   leaving content in its normal, always-visible state.
   ============================================================ */
(function(){
  if (window.__nhFallCoreInit) return;
  window.__nhFallCoreInit = true;

  function animateCount(el){
    if (el.__nhCounted) return;
    el.__nhCounted = true;
    var target = parseInt(el.getAttribute('data-countup'), 10);
    if (isNaN(target)) return;
    el.textContent = '0';
    var start = null, dur = 900;
    function step(ts){
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      el.textContent = Math.round(target * p);
      if (p < 1) {
        window.requestAnimationFrame(step);
      } else {
        el.textContent = target;
      }
    }
    window.requestAnimationFrame(step);
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var reveals = document.querySelectorAll('.nhfall-reveal');

  /* reduced motion, or no IntersectionObserver support: leave everything
     in its default visible state — never arm the hidden/offset styles. */
  if (reduce || !('IntersectionObserver' in window) || !reveals.length) return;

  reveals.forEach(function(el){ el.classList.add('reveal-armed'); });

  var io = new IntersectionObserver(function(entries, obs){
    entries.forEach(function(entry){
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      var counters = entry.target.querySelectorAll('[data-countup]');
      counters.forEach(animateCount);
      obs.unobserve(entry.target);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

  reveals.forEach(function(el){ io.observe(el); });
})();
